/**
 * Crypt pseudo box shared constants
 */
export const CRYPT_PSEUDO_VIEWBOX = '0 0 307 102';
